export const isAdminUserType = (name: string) => name.toLowerCase().replace(/\s+/g, '').includes('adminuser')

export default isAdminUserType
